import { useMemo } from 'react'
import { updateFontSizes } from '@utils'
import { useUIStore } from '@/stores'

// Backend-authored banner on the live step ("Keep your plan active" etc.). The funnel
// renders it in Layout; a drawer-hosted step has to render its own.
const OmpStepBanner = ({ session }: { session: any }) => {
  const isBannerHidden = useUIStore(s => s.isBannerHidden)
  const html = useMemo(() => updateFontSizes(session?.banner || ''), [session?.banner])

  if (!html || isBannerHidden) {
    return null
  }
  return <div className="omp-step-banner rich-text" dangerouslySetInnerHTML={{ __html: html }} />
}

export default OmpStepBanner
